import { FolderOpen, HardDrive, ShieldCheck } from 'lucide-react'

interface DestinationCardProps {
  name?: string
  supported: boolean
  disabled?: boolean
  onPick: () => void
}

export function DestinationCard({ name, supported, disabled = false, onPick }: DestinationCardProps) {
  return (
    <section className="destination-card">
      <div className="destination-icon"><HardDrive size={24} /></div>
      <div className="destination-content"><span className="kicker">DESTINO LOCAL</span><h3>{name ? 'Tu carpeta está lista' : 'Elige dónde quedará tu copia'}</h3><p>{name ? <><strong>{name}</strong> · libregoo sólo podrá escribir en esta carpeta cuando inicies una copia.</> : 'Puede ser una carpeta del ordenador, un disco USB o una ruta montada de tu NAS.'}</p><span className="local-proof"><ShieldCheck size={15} /> El destino se autoriza desde tu navegador</span></div>
      <button className="button button-secondary" type="button" onClick={onPick} disabled={!supported || disabled}><FolderOpen size={17} /> {name ? 'Cambiar carpeta' : 'Elegir carpeta'}</button>
      {!supported && <p className="destination-warning">Abre libregoo en Chrome o Edge actualizado para elegir una carpeta local.</p>}
    </section>
  )
}
